<!--  直播结束-->
<template>
  <div class="end-container">
    <div class="end-body">
      <h4 style="margin-bottom: 15px; font-size: 22px">{{$t('over.本场直播已结束')}}</h4>
      <div class="end-content">
        <div>
          <img :src="require('@/svg/liveTime.svg')" /><span
            class="end-fontColor"
            >{{$t('over.直播时长')}}</span
          >
        </div>
        <p>{{ liveTime }}</p>
      </div>
      <div class="end-content" v-if="isLike">
        <div>
          <img :src="require('@/svg/dianzan.svg')" /><span class="end-fontColor"
            >{{$t('over.点赞总数')}}</span
          >
        </div>
        <p>{{ praiseCount }}</p>
      </div>
      <div class="end-content" v-if="isReward">
        <div>
          <img :src="require('@/svg/gift.svg')" /><span class="end-fontColor"
            >{{$t('over.打赏金额')}}</span
          >
        </div>
        <p>¥{{ rewardCount }}</p>
      </div>
    </div>
  </div>
</template>

<script>
import { getParameter } from "@/utils/global";
import { globalUpdateLabel } from "@/utils/common";

export default {
  name: "",
  data() {
    return {
      rewardCount: getParameter("d"),
      liveTime: getParameter("t"),
      praiseCount: getParameter("g"),
      liveId: getParameter("liveId"),
    };
  },
  computed: {
    isReward () {
      return this.$store.state.liveInfo.liveConfig.is_reward;
    },
    isLike () {
      return this.$store.state.liveInfo.liveConfig.is_like;
    },
  },
  methods: {},
  created() {
    history.pushState(null, null, document.URL);
    window.addEventListener("popstate", function () {
      history.pushState(null, null, document.URL);
    });
  },
  mounted() {
    globalUpdateLabel()
    try {
      if (this.$msgbox) {
        this.$msgbox.close();
      }
    } catch (error) {
      console.log(error)
    }
  }
  // beforeRouteLeave(to, from, next) {},
};
</script>
<style lang='scss' scoped>
.end-container {
  background: url("../assets/images/overicon.png");
  width: 100%;
  height: 100%;
  background-repeat: no-repeat;
  background-position: center center;
  position: relative;
  color: #fff;
  .end-fontColor {
    color: #7d7f8c;
  }
  .end-body {
    width: 310px;
    height: 250px;
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    margin: auto;
  }
  .end-content {
    display: flex;
    justify-content: space-between;
    line-height: 50px;
    img {
      vertical-align: middle;
      margin-right: 5px;
    }
  }
}
</style>
